import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border-radius: 14px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    background-color: ${({ theme }) => theme.palette.primary.background};
    border-radius: 21px;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;
`;

export const SettingsButton = styled(Button).attrs({
  isFullWidth: true,
  borderRadius: 14,
})``;
